import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/web/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/pages/global-styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/providers/heroui-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/web/providers/user-provider.js");
